import dmi from './utils/deep-merge-inmutable';
import base from './base';
export default dmi(base, {
    message: {
        publishedEforms: {
            paginator: {
                rowsByPage: "Resultados por página",
            }
        },
        userActive: {
            cuil: "DNI",
            cuils: "DNI"
        },
        label: {
            dni: "DNI",
        },
        search_text_1_1: "Dni, Nombre, Apellido o Email",
        publishDocuments: {
            configIndivualPublish: {
                inputCuil: {
                    label: "DNI",
                    question: "¿Cuál es el DNI del colaborador?",
                    description: "Ingresa el DNI del colaborador al que quieres enviarle un documento"
                },
            }
        },
        certificates: {
            newCertificate: {
                personalInfo: {
                    dni: "DNI",
                },
                dni: "DNI"
            }
        },
        documentDetail: {
            commons: {
                cuil: "DNI",
            }
        }
    }
})